import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'
import { type OfficialPublicationPayload } from '#app/services/official-publications/types.ts'

export const costaRicaGacetaCitation: LegalSourceCitationBehavior<OfficialPublicationPayload> = {
	title: payload => payload.title || `La Gaceta del ${payload.publicationDate}`,
	url: payload => `/archivos/gaceta/${payload.snapshotId}`,
	fallbackUrl: snapshotId => `/archivos/gaceta/${snapshotId}`,
	inlineTagName: 'gacetadocument',
	legacyTagNames: ['GacetaDocument'],
	inlineSecondaryText: payload => payload.publicationDate,
	iconName: 'book-open',
	linkClassName: 'text-sky-700',
	summaryLabel: 'Gacetas',
	summaryTitle: payload => payload.title,
}
